export const themes = {
  default: {
    thTag: 'mb-5',
    thTextTheme: 'text-sans-3',
    thBottom: 'flex items-center justify-between mt-5',
    thAuthor: 'font-bold',
    thDate: 'text-gray-medium',
    thLikesLabel: 'font-bold text-gray-darker rtl:mr-2',
    thLikes: 'inline-flex items-center text-red rtl:mr-3',
    thIcon: 'rtl:mr-2',
    thIconSize: '1.25rem',
  },
};
